import { render, staticRenderFns } from "./OwnersModal.vue?vue&type=template&id=c1ce8280&"
import script from "./OwnersModal.vue?vue&type=script&lang=js&"
export * from "./OwnersModal.vue?vue&type=script&lang=js&"
import style0 from "./OwnersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports